import { AccountFilter } from './AccountFilter';
import { AccountTypeFilter } from './AccountTypeFilter';
import { AutomationFilter } from './AutomationFilter';
import { BookFilter } from './BookFilter';
import { BookingChannelFilter } from './BookingChannelFilter';
import { CategoryFilter } from './CategoryFilter';
import { ClassificationFilter } from './ClassificationFilter';
import { ContactsFilter } from './ContactsFilter';
import { ListingsFilter } from './ListingsFilter';
import { PartyFilter } from './PartyFilter';
import { RecurringFeeFilter } from './RecurringFeeFilter';
import { ReservationLineTypeFilter } from './ReservationLineTypeFilter';

export const CustomFilter = {
  Automation: AutomationFilter,
  Book: BookFilter,
  Category: CategoryFilter,
  Classification: ClassificationFilter,
  Listings: ListingsFilter,
  Contacts: ContactsFilter,
  Party: PartyFilter,
  AccountType: AccountTypeFilter,
  Account: AccountFilter,
  BookingChannel: BookingChannelFilter,
  ReservationLineType: ReservationLineTypeFilter,
  RecurringFee: RecurringFeeFilter,
};

export * from './AccountFilter';
export * from './AccountTypeFilter';
export * from './AutomationFilter';
export * from './BookFilter';
export * from './BookingChannelFilter';
export * from './CategoryFilter';
export * from './ClassificationFilter';
export * from './ContactsFilter';
export * from './ListingsFilter';
export * from './PartyFilter';
export * from './RecurringFeeFilter';
export * from './ReservationLineTypeFilter';
